import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import FormInput from "../Input";
import { useHistory } from "react-router-dom";
import { useContext } from "react";
import { UserDataContext } from "store/UserContext.jsx";

const FormSection = ({
    section,
    defaultValues,
    handleChange,
    startDate,
    costumeTitle,
    isDisable,
    hasError = false,
    hasNotShowAll,
}) => {
    const { location } = useHistory();
    const [userData] = useContext(UserDataContext);

    const handleDefaultValue = (inputName) => {
       
        if (inputName === "parent_food_id" && defaultValues && defaultValues["parent_food_title"]!=="") {
            return defaultValues["parent_food_title"];
        }
        if (inputName === "start") {
            return defaultValues && defaultValues["start_str"];
        } else if (inputName === "end") {
            return defaultValues && defaultValues["end_str"];
        } else {
            return defaultValues && defaultValues[inputName];
        }
    };

    //TODO: customize disabled for each page and remove this extra disabled
    const updateToppingPage = useLocation().pathname.includes("update-topping");
    const updateBatchPage = useLocation().pathname.includes("update-batch");
    const updateAssignPage = useLocation().pathname.includes("update-assign");
    const disabled =
        useLocation().pathname.includes("update") &&
        !updateToppingPage &&
        !updateAssignPage &&
        !updateBatchPage;
    const isOfflineSaleUpdatePage = location.pathname.includes(
        "update-offline-invoice"
    );
    const shelfPageForm =
        location.pathname.includes("update-shelf") ||
        (location.pathname.includes("new-shelf") &&
            userData.role === "hubsupervisor");
    return (
        <>
            <h6 className="title">{section.label}</h6>
            <div className="d-flex justify-content-between align-items-center flex-wrap">
                {section.inputs.map((input, inputIndex) => {
                    return (
                        <FormInput
                            input={input}
                            inputIndex={inputIndex}
                            key={inputIndex}
                            costumeTitle={costumeTitle}
                            defaultValue={handleDefaultValue(input.name)}
                            startDate={startDate}
                            disabled={
                                input.disable ||
                                (input.name === "vendor_id" && disabled) ||
                                (input.name === "hub_id" &&
                                    isOfflineSaleUpdatePage) ||
                                (input.name === "hub_id" && shelfPageForm) ||
                                isDisable
                            }
                            hasError={hasError}
                            handleChange={(data) =>
                                handleChange(input.name, data)
                            }
                            hasNotShowAll={hasNotShowAll}
                        />
                    );
                })}
            </div>
        </>
    );
};

FormSection.propTypes = {
    section: PropTypes.object,
    defaultValues: PropTypes.object,
    handleChange: PropTypes.func,
    costumeTitle: PropTypes.string,
    isDisable: PropTypes.bool,
    hasError: PropTypes.bool,
    hasNotShowAll: PropTypes.bool,
};

export default FormSection;
